import { useMutation } from "@tanstack/react-query";
import { apiRequest } from "../services/utils/HttpUtils";
import { IMsalContext } from "@azure/msal-react";
import { Variables } from "graphql-request";

interface Props {
	query: string,
	variables?: Variables,
	instance: IMsalContext["instance"]
	accounts: IMsalContext["accounts"]
}

export function createAssumptions(apiParams: Props) {
	const { mutate: queryAssumption, data: scenarioAssumption } = useMutation(
		["getScenarioAssumptions"], {
		mutationFn: () => {
			return apiRequest(
				apiParams)
		}
	});
	return { queryAssumption, scenarioAssumption };
}
